import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography, CircularProgress, Box } from '@mui/material';
import { getPirvMeasureById } from '../../../../server/server';

const ShowPirvDocumentModal = ({ open, register, onClose }: any) => {
	const id = register.natMeasurePirvId ?? register.pirvId;

	const [pirv, setPirv] = useState<any>(null);
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		if (open) {
			loadPirv();
		}
	}, [open]);

	const loadPirv = async () => {
		setLoading(true);
		setPirv(null);

		const resp = await getPirvMeasureById(id);

		if (resp.status === 200) {
			setPirv(resp.data?.item);
		}

		setLoading(false);
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullWidth
			maxWidth='sm'
			PaperProps={{
				sx: {
					p: 3,
				},
			}}
		>
			<p className='text-[#04438b] text-2xl font-bold' title='Веза са планом рада владе (PIRV)'>
				Одабир националног прописа у оквиру ПИРВ структуре
			</p>

			<DialogContent>
				{loading ? (
					<Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
						<CircularProgress />
					</Box>
				) : (
					<>
						<Typography sx={{ mt: 1, fontSize: 16, color: 'text.primary' }}>{pirv?.name ?? 'Нема одабраног прописа'}</Typography>

						<Typography sx={{ mt: 2, fontSize: 16, color: 'text.secondary' }}>{pirv?.comment ?? ''}</Typography>
					</>
				)}
			</DialogContent>

			<DialogActions sx={{ p: 2 }}>
				<Button variant='contained' onClick={onClose} sx={{ backgroundColor: '#0F2765' }}>
					Затвори
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ShowPirvDocumentModal;
